import React, { useState, useEffect } from 'react';
import { sortedArray } from '../../utils/utils.js';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import startCase from 'lodash/startCase';
import camelCase from 'lodash/camelCase';
import { StyledCard, StyledTableContainer } from './CheckListStyle';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { pushSelectedCheckList, pushSelectedChipArray, pushSearchLoader, pushTablePageCount, pushTableRowCount, pushTableTotalCount, pushNewChipArray, pushNewSearchChipArray } from '../../slices/customQueryBodySlice';
import Table from '../../components/reactTable/Table';
import { TablePagination } from '@material-ui/core';
import consts from '../../utils/consts';
import { pushAPIData, pushSelectedData } from '../../slices/customQuerySlice';
const {
  baseUrl,
  requestbody,
  baseUrlquery
} = consts;
import { getResponseAPIData, getPostResponseAPIData } from '../../services/apiService';
const ErrorMessageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const ErrorMessageText = styled.span`
  font-size: 18px;
  font-weight: ${props => props.weight};
`;
const useStyles = makeStyles(theme => ({
  tableRow: {
    cursor: 'pointer'
  },
  tableRowHover: {
    '&:hover': {
      backgroundColor: theme.palette.grey[200]
    }
  },
  noClick: {
    cursor: 'initial'
  },
  root: {
    width: '100%',
    overflowX: 'auto',
    margin: 0
  },
  table: {
    minWidth: 500
  },
  head: {
    whiteSpace: 'nowrap',
    backgroundColor: '#dee2e6'
  }
}));
const TablePaginationComponent = withStyles({
  select: {
    border: '1px solid #ADADAD',
    borderRadius: '2px'
  }
})(TablePagination);

const processColumns = (results = [], headerName) => {
  let cols = [];

  if (results.length > 0) {
    let keys = Object.keys(results[0]);
    keys = keys.filter(item => item !== 'checked' && item !== 'index');
    keys.forEach(key => {
      let keyName = key === 'name' ? headerName : key;
      cols.push({
        label: startCase(keyName),
        dataKey: key,
        align: 'left',
        Header: startCase(camelCase(keyName)),
        accessor: key,
        width: keyName === 'User' ? 100 : Math.min(400, startCase(camelCase(keyName)).length * 10)
      });
    });
  }

  return cols;
};

const CheckBoxList = () => {
  const dispatch = useDispatch();
  let columns = [],
      searchedItems = [];
  const classes = useStyles();
  const queryStringArray = useSelector(state => state.customQueryBody.queryStringArray);
  const dataItem = useSelector(state => state.customQuery.dataItem);
  const tablePageCount = useSelector(state => state.customQueryBody.tablePageCount);
  const tableRowCount = useSelector(state => state.customQueryBody.tableRowCount);
  const tableTotalCount = useSelector(state => state.customQueryBody.tableTotalCount);
  const postApiResponse = useSelector(state => state.customQueryHeader.postCustomQuery);
  const selectedArray = useSelector(state => state.customQuery.selectedDataArray);
  const [checkListArray, setCheckListArray] = useState([]);
  const [searchCheckList, setSearchCheckList] = useState([]);
  const [pageNumber, setPageNumber] = useState(tablePageCount ? tablePageCount : 0);
  const [totalCount, setTotalCount] = useState(tableTotalCount ? tableTotalCount : 0);
  const [rowsPerPage, setRowsPerPage] = useState(tableRowCount ? tableRowCount : 10);
  const [continuePagination, setcontinuePagination] = useState(false);
  const searchString = useSelector(state => state.customQuery.searchedText);
  const searchChipArray = useSelector(state => state.customQuery.searchChipArray);
  const existChipArray = useSelector(state => state.customQueryBody.newExistChipArray);
  const newSearchExistChipArray = useSelector(state => state.customQueryBody.newSearchExistChipArray);
  useEffect(() => {
    let selectedChecListArray = selectedArray.filter(arr => arr.name !== ''); // filtering out blank checklist

    setCheckListArray(selectedChecListArray);
    setTotalCount(tableTotalCount);
  }, [selectedArray]);
  useEffect(() => {
    if (existChipArray && existChipArray.length > 0) setCheckListArray(existChipArray);
  }, [existChipArray]);
  useEffect(() => {
    if (newSearchExistChipArray && newSearchExistChipArray.length > 0) setSearchCheckList(newSearchExistChipArray);
  }, [newSearchExistChipArray]);
  useEffect(() => {
    if (searchChipArray && searchChipArray.length > 0) setSearchCheckList(searchChipArray);
  }, [searchChipArray]);

  const handleChangePage = (event, newPage) => {
    setPageNumber(newPage);
    setcontinuePagination(true);
    dispatch(pushTablePageCount(newPage));
  };

  const handleChangeRowsPerPage = event => {
    setPageNumber(0);
    setcontinuePagination(true);
    setRowsPerPage(parseInt(event.target.value));
    dispatch(pushTablePageCount(0));
    dispatch(pushTableRowCount(parseInt(event.target.value)));
  };

  useEffect(() => {
    if (continuePagination) {
      let paginationStringOrigin = `limit=${rowsPerPage}&offset=${pageNumber + 1}`;
      let dataItemList = dataItem.recordType;
      let localBaseUrl = baseUrl;
      dispatch(pushSearchLoader(true));
      let searchTextName = dataItem.keyName.replace(/\s+/g, '') === 'Application' ? 'ApplicationName' : dataItem.keyName.replace(/\s/g, '');

      if (searchString && searchString.length > 0) {
        let appurl = baseUrlquery + 'criteria?' + `key=${encodeURIComponent(searchString)}&name=${searchTextName}` + '&' + paginationStringOrigin;
        dispatch(getResponseAPIData([appurl], 'search'));
      } else {
        let urlEntityName = dataItemList === 'user accounts' ? 'useraccount' : dataItemList.substring(0, dataItemList.length - 1);
        let urls = localBaseUrl + urlEntityName.toLowerCase() + '&' + paginationStringOrigin;

        if (dataItemList === 'applications' || dataItemList === 'environments') {
          let appurl = baseUrlquery + dataItemList + '?' + paginationStringOrigin;
          dispatch(getResponseAPIData([appurl], 'postCustomQuery'));
        } else {
          dispatch(getPostResponseAPIData([urls], requestbody, 'postCustomQuery'));
        }
      }
    }
  }, [rowsPerPage, pageNumber]);
  useEffect(() => {
    if (postApiResponse && postApiResponse[0]?.data) {
      setTotalCount(postApiResponse[0].headers.totalcount);
      dispatch(pushTableTotalCount(postApiResponse[0].headers.totalcount));
      let datafetch = [];
      let dataItemList = dataItem.recordType;
      let dataExists = '';

      if (postApiResponse[0].data.queryData) {
        dataExists = postApiResponse[0].data.queryData;
        datafetch.push({
          data: postApiResponse[0].data.queryData,
          type: dataItemList
        });
      } else if (dataItemList === 'applications' || dataItemList === 'environments') {
        if (postApiResponse[0].data.applicationDetails && postApiResponse[0].data.applicationDetails.length > 0) {
          dataExists = postApiResponse[0].data.applicationDetails;
          datafetch.push({
            data: postApiResponse[0].data.applicationDetails,
            type: 'applications'
          });
        } else if (postApiResponse[0].data.environmentDetails && postApiResponse[0].data.environmentDetails.length > 0) {
          dataExists = postApiResponse[0].data.environmentDetails;
          datafetch.push({
            data: postApiResponse[0].data.environmentDetails,
            type: 'environments'
          });
        }
      }

      dispatch(pushAPIData(datafetch));
      dispatch(pushSelectedData(dataItem));

      if (dataExists && dataExists.length > 0) {
        dispatch(pushSearchLoader(false));
      }
    }
  }, [postApiResponse]);
  useEffect(() => {
    if (checkListArray && checkListArray.length > 0 || searchCheckList && searchCheckList.length > 0) {
      let chipArray = [];
      let displayDataArray = searchString && searchString.length > 0 && searchCheckList && searchCheckList.length > 0 ? searchCheckList : checkListArray;
      let truthyArray = displayDataArray.filter(checkedItem => {
        return checkedItem.checked;
      });
      let truthyName = truthyArray.map(item => {
        return item.name;
      });
      let selectedArray = truthyName.join(' ');
      dispatch(pushSelectedCheckList(selectedArray));
      truthyName.forEach(element => {
        chipArray.push(queryStringArray[0] + ' ' + queryStringArray[1] + ' ' + element);
      });
      dispatch(pushSelectedChipArray(chipArray));
    }
  }, [checkListArray, searchCheckList, queryStringArray, dispatch]);
  let displayData = searchString && searchString.length > 0 && searchCheckList && searchCheckList.length > 0 ? searchCheckList : checkListArray;

  if (displayData && displayData.length > 0) {
    searchedItems = displayData.filter(checkListItem => {
      let itemName = '';

      if (typeof checkListItem.name === 'number') {
        itemName = checkListItem.name;
      } else {
        itemName = checkListItem.name.toLowerCase();
      }

      return itemName;
    });

    if (searchedItems.length) {
      columns = processColumns(searchedItems, queryStringArray[0]);
    }
  }

  const getCheckedObject = row => {
    let CheckedUnCheckedItem = {};

    if (row.original.name && row.original.APPLICATION && row.original.ENVIRONMENT && row.original.SERVICE_RESOURCE_TYPE) {
      CheckedUnCheckedItem = {
        name: row.original.name,
        SERVICE_RESOURCE_TYPE: row.original.SERVICE_RESOURCE_TYPE,
        ENVIRONMENT: row.original.ENVIRONMENT,
        APPLICATION: row.original.APPLICATION,
        checked: event.target.checked,
        index: row.original.index
      };
    } else if (row.original.name && row.original.APPLICATION && row.original.ENVIRONMENT) {
      CheckedUnCheckedItem = {
        name: row.original.name,
        ENVIRONMENT: row.original.ENVIRONMENT,
        APPLICATION: row.original.APPLICATION,
        checked: event.target.checked,
        index: row.original.index
      };
    } else if (row.original.name && row.original.APPLICATION && !row.original.SERVICE_RESOURCE_TYPE) {
      CheckedUnCheckedItem = {
        name: row.original.name,
        APPLICATION: row.original.APPLICATION,
        checked: event.target.checked,
        index: row.original.index
      };
    } else if (dataItem.keyName === 'Service Resource Type') {
      CheckedUnCheckedItem = {
        name: row.original.name,
        checked: event.target.checked,
        index: row.original.index
      };
    } else {
      CheckedUnCheckedItem = {
        name: row.original.name,
        APPLICATION_TYPE: row.original.APPLICATION_TYPE,
        checked: event.target.checked,
        index: row.original.index
      };
    }

    if (Object.prototype.hasOwnProperty.call(row, 'ENVIRONMENT')) {
      CheckedUnCheckedItem['ENVIRONMENT'] = row['ENVIRONMENT'];
    }

    if (Object.prototype.hasOwnProperty.call(row, 'APPLICATION')) {
      CheckedUnCheckedItem['APPLICATION'] = row['APPLICATION'];
    }

    return CheckedUnCheckedItem;
  };

  const onCheckBoxClick = (event, row) => {
    event.stopPropagation();
    const isValidRow = checkListArray.find(checkListItem => row.original.index === checkListItem.index);

    if (isValidRow) {
      let uncheckedItems = checkListArray.filter(checkListItem => row.original.index !== checkListItem.index);
      const uncheckedItem = getCheckedObject(row);
      uncheckedItems.push(uncheckedItem);
      dispatch(pushNewChipArray(sortedArray(uncheckedItems)));
    }

    if (searchCheckList && searchCheckList.length > 0) {
      const uncheckedSearchItem = getCheckedObject(row);
      var searchCheckListItems = [];
      searchCheckList.map(item => {
        let checkedItem = { ...item
        };

        if (item.index === uncheckedSearchItem.index) {
          checkedItem.checked = uncheckedSearchItem.checked;
        }

        searchCheckListItems.push(checkedItem);
      });
      dispatch(pushNewSearchChipArray(sortedArray(searchCheckListItems)));
    }
  };

  const handleSortBy = () => {};

  return /*#__PURE__*/React.createElement(StyledCard, null, /*#__PURE__*/React.createElement(StyledTableContainer, {
    id: "infinite-scrolling-table",
    className: classes.root
  }, searchedItems && searchedItems.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    columns: columns,
    data: searchedItems,
    checkListClick: onCheckBoxClick,
    isCheckList: true,
    handleSort: handleSortBy
  }), /*#__PURE__*/React.createElement(TablePaginationComponent, {
    rowsPerPageOptions: [10, 25, 50, 100],
    component: "div",
    count: parseInt(totalCount),
    page: pageNumber,
    labelDisplayedRows: ({
      page,
      count
    }) => `Page ${page + 1} of  ${Math.ceil(count / rowsPerPage) != 0 ? Math.ceil(count / rowsPerPage) : 1}`,
    rowsPerPage: rowsPerPage,
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  })) : /*#__PURE__*/React.createElement(ErrorMessageWrapper, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ErrorMessageText, {
    weight: 600
  }, "We couldn't find results for \"", searchString, "\""), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ErrorMessageText, {
    weight: 400
  }, "Please double check your spelling or try different words."))));
};

export default CheckBoxList;